export const formatSessionTimeSeconds = (seconds: number): string => {
  const total = Math.max(0, Math.trunc(seconds))
  if (total === 0) return '0s'
  if (total < 60) return `${total}s`

  const hours = Math.floor(total / 3600)
  const minutes = Math.floor((total % 3600) / 60)
  const remainingSeconds = total % 60

  if (total < 3600) {
    if (remainingSeconds === 0) return `${minutes}m`
    return `${minutes}m ${remainingSeconds}s`
  }

  if (minutes === 0) return `${hours}h`
  return `${hours}h ${minutes}m`
}
